//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../../constant/Endpoint";
import NACell from "../../Reusable/DataTable/NACell";
import TableActionButton from "../../Reusable/TableActionButton";
import DataTable from "../../Reusable/DataTable";
import moment from "moment";
import SwitchButton from "../../Reusable/SwitchButton/SwitchButton";
const ContactContent = (props: any) => {
  const { handleIsActive, handleIsEnableEmail, handleIsEnableSMS } = props;
  const { handleIsDefaultContact } = props;
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    // {
    //   header: "First Name",
    //   accessorKey: "first_name",
    //   cell: NACell,
    // },
    // {
    //   header: "Last Name",
    //   accessorKey: "last_name",
    //   cell: NACell,
    // },
    // {
    //   header: "Phone Number",
    //   accessorKey: "phone_number",
    //   cell: NACell,
    // },
     {
          header: 'Default',
          accessorKey: 'is_default',
          cell: ({ row, getValue }) => (
            <SwitchButton
              id={row?.original?.id}
              value={getValue()}
              disabled={false}
              onChange={handleIsDefaultContact}
            />
          ),
        },
    // {
    //     header: "Date",
    //     accessorKey: "created_at",
    //     cell: ({ row, getValue }: any) => {
    //       return (
    //         <>
    //           {getValue() ? (
    //             <p className={tw`max-w-[80px]`}>
    //               {moment(getValue()).format("YY-MM-DD HH:mm:ss")}
    //             </p>
    //           ) : (
    //             "N/A"
    //           )}
    //         </>
    //       );
    //     },
    //   },
    //   {
    //   header: 'Content',
    //   accessorKey: 'content',
    //   cell: NACell,
    // },
  ];

  return (
    <DataTable
      url={APIS.SENDER_SMS}
      queryKey={"contacts"}
      columns={defaultColumns}
      tableName={"Branch"}
    />
  );
};

export default ContactContent;
